import { connect } from "react-redux";
import AppHeader, {
  AppHeaderProps as _AppHeaderProps,
  AppHeaderDOMProps,
  AppHeaderUser
} from "./app-header-view";
import { AppState } from "../../store/AppState";
import OrganizationUtils from "../../utils/organization";
import { setOrg } from "../../actions";
import {
  PickReduxDispatchProps,
  PickReduxStateProps
} from "../../util/typeUtil";
import AuthenticationUtils from "../../utils/authentication";
import InProgressUtils from "../../utils/in-progress";

// Own props, i.e. props that this component takes as input
interface AppHeaderProps extends AppHeaderDOMProps {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<_AppHeaderProps, AppHeaderProps>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _AppHeaderProps,
  AppHeaderProps
>;

function mapStateToProps(state: AppState): ReduxStateProps {
  return {
    disableOrganizationSelect:
      InProgressUtils.selectInProgressLength(state) > 0,
    selectedOrganization: OrganizationUtils.selectSelectedOrganization(state),
    organizations: OrganizationUtils.selectAppOrganizations(state),
    user: {
      id: AuthenticationUtils.selectAuthenticationUserId(state) as string,
      name: AuthenticationUtils.selectAuthenticationUserDisplayName(state),
      email: AuthenticationUtils.selectAuthenticationUserEmail(state)
    } as AppHeaderUser
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    OrganizationUtils.compareSelectedOrganizationIdStates(next, prev) &&
    AuthenticationUtils.compareAuthenticationUserDisplayNameStates(
      next,
      prev
    ) &&
    AuthenticationUtils.compareAuthenticationUserIdStates(next, prev) &&
    AuthenticationUtils.compareAuthenticationUserEmailStates(next, prev) &&
    OrganizationUtils.compareAppOrganizationsStates(next, prev)
  );
}
const dispatchActions: ReduxDispatchProps = {
  onSelectOrganization: setOrg
};
export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  AppHeaderProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual
})(AppHeader);
